import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "s20 widget px-6 pt-8 pb-2" }
const _hoisted_2 = { class: "s20 gap-6 px-5 pb-8 collapse-content active" }
const _hoisted_3 = { class: "flex items-center gap-6" }
const _hoisted_4 = { class: "s7" }
const _hoisted_5 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_6 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_7 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_8 = { class: "s7" }
const _hoisted_9 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_10 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_11 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}
const _hoisted_12 = { class: "s6" }
const _hoisted_13 = { class: "secondary-font font-semibold text-grey-900 my-2 text-5xl" }
const _hoisted_14 = { class: "secondary-font font-semibold text-grey-700 mb-4" }
const _hoisted_15 = {
  class: "h-40 rounded-100 position-relative overflow-hidden",
  style: {"width":"100%","background-color":"rgba(var(--color-black-rgb), 0.1)"}
}

import { reactive, ref, watch, inject } from 'vue';
    import axios from 'axios';
    import { formatAmount } from '@/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FinancePrelevementsWalletComponent',
  props: {
    startupInfos: {}
  },
  setup(__props: any, { expose: __expose }) {

    // @ts-expect-error raison: lib externe mal typée
    __expose({ doGetWalletDetailsInfos });

    const props = __props;
    const collectivite = ref(null as any);
    const loading = ref(false);
    const errorMessage = ref('');
    const statsInfos = reactive({
        montant_decaissement: 0,
        total_decaissement: 0,
        montant_prelevement: 0,
        solde: 0
    });

    watch(() => props.startupInfos, (newVal: any) => {
        const isFirstChanged = !collectivite.value;
        collectivite.value = newVal.collectivite;
        if (collectivite.value && isFirstChanged) {
            doGetWalletDetailsInfos();
        }
    }, { immediate: true });

    async function doGetWalletDetailsInfos() {
        try {
            loading.value = true;
            errorMessage.value = '';
            const httpResponse = await axios.get(`/backoffice/finance/prelevements/get_wallet_infos/${collectivite.value.id}`);
            Object.assign(collectivite.value, httpResponse.data);
        } catch (error: any) {
            errorMessage.value = error.message;
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"s10 mt--4 ml--4 mb-5 collapse-open active\"><span class=\"px-5 py-4 bg-color-black rounded-100 text-xl\"><img src=\"/icons/icon-panel-open.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-open\" alt=\"\"><img src=\"/icons/icon-panel-close.svg\" class=\"size-xs icon-neutral mr-2 collapse-icon-close\" alt=\"\"> Wallet / Décaissement </span></div><div class=\"s10 mt--5-5 flex-right\"></div>", 2)),
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "clear-both h-10" }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-color-black" }),
            _createTextVNode(" Solde ")
          ], -1)),
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(formatAmount)(collectivite.value.solde)) + " F", 1),
          _createElementVNode("h5", _hoisted_6, _toDisplayString(collectivite.value.solde_percent) + "%", 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-black",
              style: _normalizeStyle({'width': collectivite.value.solde_percent + '%'})
            }, _toDisplayString(collectivite.value.solde_percent) + "% ", 5)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-color-1000" }),
            _createTextVNode(" Montant Décaissé ")
          ], -1)),
          _createElementVNode("h1", _hoisted_9, _toDisplayString(_unref(formatAmount)(collectivite.value.total_montant_decaissements)) + " F", 1),
          _createElementVNode("h5", _hoisted_10, _toDisplayString(collectivite.value.decaissements_percent) + "%", 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-color-1000 text-white",
              style: _normalizeStyle({'width': collectivite.value.decaissements_percent + '%'})
            }, _toDisplayString(collectivite.value.decaissements_percent) + "% ", 5)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "flex gap-3 secondary-font font-semibold text-grey-700" }, [
            _createElementVNode("div", { class: "circle-medium bg-green-light" }),
            _createTextVNode(" Dernier décaissement ")
          ], -1)),
          _createElementVNode("h1", _hoisted_13, _toDisplayString(_unref(formatAmount)(collectivite.value.last_montant_decaissement)) + " F", 1),
          _createElementVNode("h5", _hoisted_14, _toDisplayString(collectivite.value.last_decaissement_percent) + "%", 1),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: "h-100p flex align-items-center justify-content-left rounded-100 text-xl px-5 bg-green-light",
              style: _normalizeStyle({'width': collectivite.value.last_decaissement_percent + '%'})
            }, _toDisplayString(collectivite.value.last_decaissement_percent) + "% ", 5)
          ])
        ])
      ])
    ])
  ]))
}
}

})